import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import * as authConsts from '../../auth-constants'
import { SignupService } from '../../service/signup.service';
import { EmailOTPService } from '../../service/email-otp.service';
import { Subscription, interval } from 'rxjs';

let remainingTimeDefault = 100
@Component({
  selector: 'app-verify-otp',
  templateUrl: './verify-otp.component.html',
  styleUrls: ['./verify-otp.component.scss']
})
export class VerifyOtpComponent implements OnInit,OnDestroy{
  otpInputConfig = authConsts.verifyPhoneOtpConfig
  @Input() userProfile: any;
  isValid:boolean = false
  remainingTime = remainingTimeDefault
  isResendAllowed = false
  subscriptions!:Subscription[]

  constructor(private signupService:SignupService,private emailOtpService:EmailOTPService){}

  ngOnInit(): void {
    this.signupService.getOTPTimer().subscribe(data=>{
      this.remainingTime = data?.emailResendEnableInSeconds
      remainingTimeDefault = data?.emailResendEnableInSeconds
    })

    const buttonStateSubs = this.emailOtpService.getResendButtonState().subscribe(state=>{
      this.isResendAllowed = state
      if(state) this.remainingTime = 0
    })

    const intervalSubs = interval(1000).subscribe(_=>{
      this.remainingTime--
      this.isResendAllowed = !(this.remainingTime > 0)
      this.emailOtpService.setResendButtonState(this.isResendAllowed)
    })
    this.subscriptions = [intervalSubs,buttonStateSubs]
  }

  async resendOTP(){
    if(this.isResendAllowed) {
      await this.emailOtpService.sendEmailOTP(this.userProfile.email,this.userProfile.subtenant)
      this.remainingTime = remainingTimeDefault
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  handleOtpChange(value: string[]): void {
    this.isValid = false
  }

  handleFillEvent(value: string): void {
    this.isValid = true
    this.userProfile.otp = value;
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((x:any)=>x?.unsubscribe())
  }
}
